import React, { useState } from 'react'
import { Typography, Paper, Button, FormControl, Input, InputLabel } from '@material-ui/core'
import TextField from '@material-ui/core/TextField';
import { Link, withRouter } from 'react-router-dom'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import firebase from '../firebase'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';



function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

function SignIn(props) {
	const { classes } = props

	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [open, setOpen] = React.useState(false);
	const [msg, setMsg] = React.useState(undefined);
	const [typeMsg, setTypeMsg] = React.useState(undefined);

	const alertMsg = (msg, type) => {
	  setOpen(true);
	  setMsg(msg);
	  setTypeMsg(type);
	};
  
	const handleClose = (event, reason) => {
	  if (reason === 'clickaway') {
		return;
	  }
	  setOpen(false);
	};

	async function login(e) {
		e.preventDefault()
		try {
			await firebase.login(email, password);
			props.history.replace(baseURL+'/dashboard')
		} catch(error) {
			alertMsg(error.message, 'error');
		}
	}

	const theme = createMuiTheme({
		palette: {
		  primary: {
			main: '#919191'
		  }
		},
	  });
	  const baseURL = process.env.PUBLIC_URL;

	return (
		<ThemeProvider theme={theme}>
			<form onSubmit={login}>
				<main className="login">
					<Snackbar
						anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
						}}
						open={open}
						autoHideDuration={4000}
						onClose={handleClose}
					>
					<Alert onClose={handleClose} severity={typeMsg}>
					{msg}
					</Alert>
					</Snackbar>
					<header className="loginHeader">
						<img className="logoLogin2" src={require('../../images/logo.svg')} />
						<h3 className="loginHTitleHeader">BIENVENIDO</h3>
					</header>
					<div className="loginContainer">
						<FormControl margin="normal" required fullWidth>
							<TextField id="email" name="email" label="Email" color="primary" variant="outlined" autoFocus value={email} onChange={e => setEmail(e.target.value)} />
						</FormControl>
						<FormControl margin="normal" required fullWidth>
							<TextField name="password" label="Contraseña" color="primary"  type="password" id="password" variant="outlined" autoComplete="off" value={password} onChange={e => setPassword(e.target.value)} />
						</FormControl>
						<div className="loginBtnOthers">
							<Link to={baseURL+"/forget-pass"}><div className="loginBtnSecundary red">Olvidé mi contraseña</div></Link>
							<Link to={baseURL+"/register"}><div className="loginBtnSecundary red">Soy nuevo Usuario</div></Link>
						</div>
					</div>	
					<div className="btnContainerLogin">
						<button type="submit" className="loginBtnPrincipal">Acceder</button>
					</div>
				</main>
			</form>
		</ThemeProvider>
	)
}

export default withRouter(SignIn)